import styled from 'styled-components';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const getIconColor = (appearance) => {
    switch (appearance) {
        case 'success':
            return themeGet('colors.green.500');
        case 'danger':
            return themeGet('colors.red.500');
        case 'warning':
            return themeGet('colors.yellow.500');
        case 'info':
        default:
            return themeGet('colors.blue.500');
    }
};
export const StyledTitle = styled(Typography) `
  line-height: ${pxToRem(18)};
`;
export const StyledMessage = styled(Typography) `
  line-height: ${pxToRem(18)};
`;
export const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Container = styled.div `
  display: flex;
  align-items: stretch;
  gap: ${themeGet('spacing.lg')};
  padding: ${themeGet('spacing.lg')};
  border-radius: ${themeGet('borderRadius.lg')};
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  background-color: ${themeGet('colors.background.50')};
  box-shadow: ${themeGet('dropShadow.100')};

  ${(props) => props.$onlyMessage &&
    `
    align-items: center;

    ${ContentContainer} {
      justify-content: center;
      min-height: ${pxToRem(36)};
    }}
  `}
`;
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
  border-radius: ${themeGet('borderRadius.lg')};
  background-color: ${themeGet('colors.background.75')};

  [data-icon='falcon'] {
    color: ${(props) => getIconColor(props.$appearance)};
  }
`;
